import { useEffect, useState } from "react";
import { faqs } from "@/mocks/opinion";

export default function FaqSection() {
  const [open, setOpen] = useState(0);

  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-schema";
    script.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(script);
    return () => {
      document.getElementById("faq-schema")?.remove();
    };
  }, []);

  return (
    <section id="faq" className="bg-background-100/70">
      <div className="mx-auto max-w-4xl px-4 md:px-6 py-12 md:py-16">
        <div className="text-center">
          <p className="inline-flex items-center gap-2 text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600">
            <span className="h-px w-6 bg-primary-500"></span> FAQ
          </p>
          <h2 className="mt-2 font-heading text-2xl md:text-4xl font-black text-foreground-950">常见问题</h2>
          <p className="mt-3 text-sm md:text-base text-foreground-700">
            关于九一吃瓜的内容来源、观点整理方式，这里一次性说清楚。
          </p>
        </div>

        <div className="mt-8 space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={f.q}
                className="overflow-hidden rounded-xl border border-background-200 bg-background-50"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-4 py-4 md:px-5 text-left cursor-pointer"
                >
                  <span className="flex items-center gap-3">
                    <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-sm font-bold ${isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-800"}`}>
                      Q
                    </span>
                    <h3 className="text-sm md:text-base font-semibold text-foreground-950">{f.q}</h3>
                  </span>
                  <i
                    className={`ri-arrow-down-s-line shrink-0 text-xl text-foreground-500 transition-transform ${isOpen ? "rotate-180" : ""}`}
                    aria-hidden="true"
                  ></i>
                </button>
                {isOpen && (
                  <div className="px-4 pb-5 md:px-5">
                    <p className="pl-10 text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}